<template>
  <div class="wrapper">
    <pdf
      v-for="i in total"
      :src="stream"
      :page="i"
      :key="'pdfPreview' + i"
    ></pdf>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  data() {
    return {
      total: 0,
      stream: "",
    };
  },
  props: {
    url: String,
  },
  components: { pdf },
  created() {},
  mounted() {
    let loadingTask = pdf.createLoadingTask(this.url);
    loadingTask.promise
      .then((pdf) => {
        console.log(pdf.numPages);
        this.total = pdf.numPages;
        this.stream = loadingTask;
      })
      .catch((err) => {
        console.log("pdf坏了");
      });
  },
  methods: {},
};
</script>

<style scoped lang="less">
.wrapper {

  span{
    height: 60%;
  }
}
</style>
